export default "__VITE_ASSET__Do2fdOs3__"